import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { Badge } from "@/components/ui/badge";
import { listMyRfqs } from "@/lib/vendor-portal.functions";

export const Route = createFileRoute("/vendor/rfqs/")({
  component: RfqsIndex,
});

function RfqsIndex() {
  const fn = useServerFn(listMyRfqs);
  const { data, isLoading } = useQuery({ queryKey: ["vendor", "rfqs"], queryFn: () => fn({}) });
  const rfqs = data?.rfqs ?? [];
  const quotations = data?.quotations ?? [];
  const qByRfq = new Map(quotations.map((q: any) => [q.rfq_id, q]));

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">RFQs</h1>
      <div className="rounded-md border bg-card">
        {isLoading ? (
          <p className="p-4 text-sm text-muted-foreground">Loading…</p>
        ) : rfqs.length === 0 ? (
          <p className="p-4 text-sm text-muted-foreground">No RFQs yet.</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="border-b bg-muted/40 text-xs uppercase text-muted-foreground">
              <tr>
                <th className="px-3 py-2 text-left">RFQ No.</th>
                <th className="px-3 py-2 text-left">Title</th>
                <th className="px-3 py-2 text-left">Deadline</th>
                <th className="px-3 py-2 text-left">Status</th>
                <th className="px-3 py-2"></th>
              </tr>
            </thead>
            <tbody>
              {rfqs.map((r: any) => {
                const q = qByRfq.get(r.id) as any;
                return (
                  <tr key={r.id} className="border-b last:border-0">
                    <td className="px-3 py-2 font-medium">{r.rfq_no ?? r.id.slice(0, 8)}</td>
                    <td className="px-3 py-2">{r.title ?? "—"}</td>
                    <td className="px-3 py-2">{r.response_deadline ?? "—"}</td>
                    <td className="px-3 py-2">
                      {q ? <Badge>{q.status ?? "submitted"}</Badge> : <Badge variant="outline">Awaiting quote</Badge>}
                    </td>
                    <td className="px-3 py-2 text-right">
                      <Link to={"/vendor/rfqs/$rfqId" as any} params={{ rfqId: r.id } as any} className="text-primary hover:underline">
                        {q ? "View / Edit" : "Submit quote"} →
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
